export const statusList: string[] = [
  'backlog',
  'for development',
  'in progress',
  'done',
];

export const priorityList: string[] = ['Highest', 'High', 'Low', 'Lowest'];

export const typeList: string[] = ['Task', 'Bug', 'Story'];

export const roleList: string[] = ['Author', 'Reporter', 'Asignee'];

export const filterByList: string[] = ['Role', 'Status', 'Type', 'Priority'];
